import { apiGet, apiPost, apiPut, apiDelete } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import { showFailure, showSuccess } from 'actions/notificationActions';
import {
  FETCH_PROJECT,
  UPDATE_PROJECT,
  FETCH_ALL_PROJECTS,
  CLEAR_SELECTED_PROJECT,
  FILTER_PROJECTS,
  FETCH_PROJECT_STATS,
  SHOW_FILTERED_PROJECTS,
  FETCH_PROJECT_FILTERED_PURCHASE_ORDERS,
  STORE_PROJECT_PURCHASE_ORDERS,
  LINK_PURCHASE_ORDER_TO_PROJECT,
  UNLINK_PURCHASE_ORDER_FROM_PROJECT,
  FETCH_FILTERED_TICKETS,
  SHOW_FILTERED_TICKETS,
  LINK_TICKET_TO_PROJECT,
  UNLINK_TICKET_FROM_PROJECT,
  REMOVE_UNLINKED_TICKET_FROM_PROJECT,
} from './actionTypes';

const baseUrl = 'landlords/ticketing';

export function fetchProject(projectID) {
  if (!projectID) {
    return dispatch => {
      return dispatch({
        type: CLEAR_SELECTED_PROJECT,
      });
    };
  }

  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/projects/${projectID}`;
    return dispatch({
      type: FETCH_PROJECT,
      payload: apiGet(url).catch(error => {
        dispatch(showFailure(error));
      }),
    });
  };
}

export function fetchAllProjects(offset = 0) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/filtered_projects?offset=${offset}`;
    return dispatch({
      type: FETCH_ALL_PROJECTS,
      payload: apiPost(url).catch(error => {
        dispatch(showFailure(error));
      }),
    });
  };
}

export function fetchProjectStats() {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/project_stats`;
    return dispatch({
      type: FETCH_PROJECT_STATS,
      payload: apiGet(url).catch(error => {
        dispatch(showFailure(error));
      }),
    });
  };
}

export function fetchFilteredProjects(subset = 'all', offset = 0, options = {}) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/filtered_projects?subset=${subset}&offset=${offset}`;
    return dispatch({
      type: FILTER_PROJECTS,
      payload: apiPost(url, options),
    })
      .done(response => {
        fetchProjectStats();
        dispatch({
          type: SHOW_FILTERED_PROJECTS,
          payload: response.value,
          offset,
          subset,
        });
      })
      .catch(error => {
        dispatch(showFailure(error));
      });
  };
}

export function fetchFilteredProjectTickets(projectID, offset = 0, options = {}) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/projects/${projectID}/filtered_maintenance_tickets?&offset=${offset}`;
    return dispatch({
      type: FETCH_FILTERED_TICKETS,
      payload: apiPost(url, options),
    })
      .done(response => {
        fetchProjectStats();
        dispatch({
          type: SHOW_FILTERED_TICKETS,
          payload: response.value,
          offset,
        });
      })
      .catch(error => {
        dispatch(showFailure(error));
      });
  };
}

export function postProject(formData) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/landlords/ticketing/projects`;
    return apiPost(url, formData);
  };
}

export function putProject(formData) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/projects/${formData.id}`;
    return dispatch({
      type: UPDATE_PROJECT,
      payload: apiPut(url, formData)
        .done(response => {
          dispatch(showSuccess('landlordPortal.maintenance.projects.updateSuccess'));
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}

export function linkTicketToProject(projectID, maintenanceTicketID) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/projects/${projectID}/ticket`;
    return dispatch({
      type: LINK_TICKET_TO_PROJECT,
      payload: apiPut(url, { maintenance_ticket_id: maintenanceTicketID })
        .done(response => {
          dispatch(showSuccess('landlordPortal.maintenance.projects.ticketSuccessfullyLinked'));
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}

export function fetchFilteredProjectPurchaseOrders(projectId, offset, options) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/projects/${projectId}/filtered_purchase_orders?offset=${offset}`;
    return dispatch({
      type: FETCH_PROJECT_FILTERED_PURCHASE_ORDERS,
      payload: apiPost(url, options)
        .done(response => {
          const purchaseOrders = response.purchase_orders.data.map(
            purchaseOrder => purchaseOrder.attributes
          );
          dispatch({
            type: STORE_PROJECT_PURCHASE_ORDERS,
            payload: {
              purchaseOrders: purchaseOrders,
              offset,
            },
          });
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}

export function unlinkTicketFromProject(projectID, maintenanceTicketID) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/projects/${projectID}/ticket/${maintenanceTicketID}`;
    return dispatch({
      type: UNLINK_TICKET_FROM_PROJECT,
      payload: apiDelete(url)
        .done(response => {
          dispatch(showSuccess('landlordPortal.maintenance.projects.ticketSuccessfullyUnlinked'));
          dispatch({ type: REMOVE_UNLINKED_TICKET_FROM_PROJECT, maintenanceTicketID });
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}

export function linkPurchaseOrderToProject(projectId, purchaseOrderId) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/projects/${projectId}/purchase_orders/${purchaseOrderId}`;
    return dispatch({
      type: LINK_PURCHASE_ORDER_TO_PROJECT,
      payload: apiPut(url)
        .done(response => {
          dispatch(showSuccess('landlordPortal.maintenance.projects.linkedToPOSuccess'));
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}

export function unlinkPurchaseOrderFromProject(projectId, purchaseOrderId) {
  return dispatch => {
    const url = `${Auth.getApiUrl()}/${baseUrl}/projects/${projectId}/purchase_orders/${purchaseOrderId}`;
    return dispatch({
      type: UNLINK_PURCHASE_ORDER_FROM_PROJECT,
      payload: apiDelete(url)
        .done(response => {
          dispatch(showSuccess('landlordPortal.maintenance.projects.unlinkedFromPOSuccess'));
        })
        .catch(error => {
          dispatch(showFailure(error));
        }),
    });
  };
}
